module.exports = __webpack_public_path__ + "img/s1-1.295dd4ad.png";